import { useState, useEffect } from 'react';

export const useIsHomePage = () => {
  const [isHomePage, setIsHomePage] = useState(false);

  useEffect(() => {
    if (window.location.pathname === '/') {
      setIsHomePage(true);
    }
  }, []);

  return isHomePage;
};
